export function getWebLandingUrl(landing_url: string) {
  return isDeepLink(landing_url) ? extractWebLandingUrl(landing_url) : landing_url;
}

function isDeepLink(url?: string) {
  return url?.startsWith('zigzag://');
}

function extractWebLandingUrl(landing_url: string) {
  const url_part = landing_url.split('?')?.[1];
  return new URLSearchParams(url_part).get('url');
}
